import { Tab } from '@headlessui/react'
import { PicklistStatusDesc, PicklistReturnStatusDesc } from '../constants/EnumType'

type TabProps = {
  menus: string[]
  onChanged: (idx: number) => void
  selectedIndex: number
  className?: string
  classNameTab?: string
  classNameSelectedBg?: string
}

function classNames(...classes : any) {
  return classes.filter(Boolean).join(' ')
}

const ButtonGroup = ({ 
  menus, 
  selectedIndex = 0, 
  onChanged, className,
  classNameTab = '',
  classNameSelectedBg = 'bg-blue-100'
} : TabProps) => {
  return <Tab.Group
    onChange={onChanged}
    defaultIndex={selectedIndex}
    key={selectedIndex}>
    <Tab.List className={className}>
      {menus.map(menu => (
        <Tab
          key={menu}
          className={({ selected }) =>
            classNames(
              ' w-full p-2 text-base leading-5 font-bold text-blue-700 border-blue-700 border border-r-0 disabled:text-gray-400 disabled:border-gray-400',
              selected ? classNameSelectedBg : '',
              ' first:rounded-l last:rounded-r last:border-r',
              classNameTab
            )
          }
        >
        {getValueByKeyForStringEnum(menu)}
        </Tab>
      ))}
    </Tab.List>
  </Tab.Group>
}

function getValueByKeyForStringEnum(value: string) {
  return Object.entries(PicklistStatusDesc).find(([key, val]) => key === value)?.[1]
    || Object.entries(PicklistReturnStatusDesc).find(([key, val]) => key === value)?.[1]
    || value;
}

export default ButtonGroup